import React from 'react';
import Icon from '../icon/Icon';
import { ButtonLink } from '../button/ButtonLink';
import { Button } from '../button/Button';
import { Container } from '../container/Container';
import classNames from 'classnames';
const Banner = ({ className, iconColor, iconPath, iconTitle, onClick, href, buttonText, color, children, }) => {
    const classNameResult = classNames('ac-banner', className);
    return (React.createElement("div", { className: classNameResult },
        React.createElement(Container, { className: 'ac-banner-container' },
            React.createElement("div", { className: 'd-flex' },
                React.createElement(Icon, { path: iconPath, color: iconColor, size: 2, className: 'ac-icon-banner', title: iconTitle }),
                React.createElement("div", { className: 'ac-text-banner' }, children)),
            href ? (React.createElement(ButtonLink, { href: href, color: color, className: 'ac-button-banner' }, buttonText)) : (React.createElement(Button, { onClick: onClick, color: color, className: 'ac-button-banner' }, buttonText)))));
};
export { Banner };
//# sourceMappingURL=Banner.js.map